import React from 'react';
import { Spinner, Text, Table, Thead, Tbody, Tr, Th, Td, Center } from '@chakra-ui/react';

interface KeyValue {
  key: string;
  value: string | number | React.ReactNode;
}

interface KeyValueTableProps {
  isLoading: boolean;
  data: KeyValue[];
  headers?: {
    label: string;
    value: string;
  };
}

const KeyValueTable = ({ isLoading, data, headers }: KeyValueTableProps) => {
  const columnLabel = headers?.label || 'Nazwa';
  const columnValue = headers?.value || 'Wartość';

  return (
    <Table className="w-full">
      <Thead className="text-xs bg-white">
        <Tr>
          <Th
            className="w-1/2 border border-r-0 rounded-lg rounded-r-none border-gray-200 py-3 px-4"
            fontWeight={400}
            textTransform="capitalize">
            {columnLabel}
          </Th>
          <Th
            className="border border-l-0 rounded-lg rounded-l-none border-gray-200 py-3 px-4"
            fontWeight={400}
            textTransform="capitalize">
            {columnValue}
          </Th>
        </Tr>
      </Thead>
      <Tbody className="text-sm font-medium text-grayLight-900">
        {isLoading ? (
          <Tr>
            <Td colSpan={2}>
              <Center py={6}>
                <Spinner size="md" />
              </Center>
            </Td>
          </Tr>
        ) : data.length === 0 ? (
          <Tr>
            <Td colSpan={2}>
              <Center py={6}>
                <Text>Brak danych</Text>
              </Center>
            </Td>
          </Tr>
        ) : (
          data.map((item, index) => (
            <Tr key={`row-${index}`} className="border-t border-x bg-white">
              <Td className="px-6 py-5 text-grayLight-600">{item.key}</Td>
              <Td className="px-6 py-5 text-grayLight-600">{item.value}</Td>
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
};

export default KeyValueTable;
